const LYRIC_API_URL_MAP: Record<string, string> = {
  'secure.fit2.lyric.adp.com': 'https://pequity-fit.adp.com/api',
  'secure.iat.lyric.adp.com': 'https://pequity-iat.adp.com/api',
  'secure.uat.lyric.adp.com': 'https://pequity-uat.adp.com/api',
  'secure.lyric.adp.com': 'https://pequity.adp.com/api',
};

const resolveDevUrl = (): string => {
  const baseUrl = import.meta.env.VITE_PEQUITY_BASE_URL
    ? `http://${import.meta.env.VITE_PEQUITY_BASE_URL}/api`
    : 'http://localhost:8000/api';
  const url = new URL(baseUrl);

  const isFeatureTest = !!window.localStorage.getItem('TestServerPort');
  if (isFeatureTest) {
    url.port = `${window.localStorage.getItem('TestServerPort')}`;
    const subdomain = window.localStorage.getItem('TestServerSubdomain');
    if (subdomain) {
      url.hostname = `${subdomain}.${url.hostname}`;
    }
  } else {
    const apiHostname = url.hostname;
    const browserHostname = window.location.hostname;
    if (browserHostname !== apiHostname && browserHostname.endsWith(`.${apiHostname}`)) {
      url.hostname = browserHostname;
    }
  }

  return url.href;
};

const getApiUrl = (): string => {
  const explicitUrl: string | undefined = import.meta.env.VITE_PEQUITY_API_URL;
  if (explicitUrl) return explicitUrl;

  const lyricUrl = LYRIC_API_URL_MAP[window.location.hostname];
  if (lyricUrl) return lyricUrl;

  if (import.meta.env.PROD) {
    return `${window.location.origin}/api/`;
  }

  return resolveDevUrl();
};

export const API_URL = getApiUrl();

export const resolveApiOrigin = (): string => {
  if (!API_URL) return '';
  try {
    return new URL(API_URL).origin;
  } catch {
    return API_URL;
  }
};

export const resolveWebSocketUrl = (): string => {
  const origin = resolveApiOrigin();
  if (!origin) return '';
  const wsProtocol = origin.startsWith('https') ? 'wss' : 'ws';
  return `${wsProtocol}://${new URL(origin).host}/ws`;
};
